import parse from "html-react-parser";
import React from "react";

type HtmlRenderProps = {
  html?: string;
};

const HtmlRender: React.FC<HtmlRenderProps> = ({ html }) => {
  return <div>{!!html ? parse(html) : undefined}</div>;
};

export default HtmlRender;
